import React from "react";
import { Link } from "react-router-dom";

import search from "../../public/search.svg";
import search_dark from "../../public/search_dark.svg";

import wheretogo_1 from "../../public/wheretogo-jeseniky/wheretogo_1.png";
import wheretogo_2 from "../../public/wheretogo-jeseniky/wheretogo_2.png";
import wheretogo_3 from "../../public/wheretogo-jeseniky/wheretogo_3.png";
import wheretogo_4 from "../../public/wheretogo-jeseniky/wheretogo_4.png";
import wheretogo_5 from "../../public/wheretogo-jeseniky/wheretogo_5.png";


import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider"

import { useUserContext } from "../../context/userContext";


const KamSeVydatVJesenikach = () => {

  const { user } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);


  return (
    <>
      <section className={darkMode ? "where__to--go dark" : "where__to--go light"}>
        <div className="container">
          <div className="where__to--go--heading">
            <img src={darkMode ? search_dark : search} alt="" />
            <h1 className={darkMode ? "dark-text" : "light-text"}>Kam se vydat v Jeseníkách</h1>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_1} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Praděd</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Praděd je vrchol, nacházející se Hrubém Jeseníku, nejvyšší
                vrchol tohoto pohoří. Celkově jde o 5. nejvyšší horu České
                republiky, také druhou nejprominentnější a třetí
                nejizolovanější.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/jeseniky/kamsevydat/praded">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_2} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Šerák</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Vrchol této hory má stupňovitý tvar a horniny zde vytvořily
                mrazový srub. Zajímavostí této hory je takzvaný Keprnický kar na
                východní stráni, který zde zůstal jako památka na ledovec, jenž
                se tu v dávné minulosti nacházel.
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/jeseniky/kamsevydat/serak">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
          <div className="where__to--go--container">
            <div className="where__to--go--image">
              <img src={wheretogo_3} alt="" />
            </div>
            <div className="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Karlova studánka</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Karlova Studánka je lázeňská obec ležící v okrese Bruntál. Jen
                kousek odsud leží nejvyšší vrchol Moravy a českého Slezska –
                Praděd. Do roku 1949 byla Karlova Studánka osadou obce Suchý
                Zejf
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/jeseniky/kamsevydat/karlovastudanka">
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">

          {user ?
         <div className="where__to--go--container">
          <div className="where__to--go--image">
            <img src={wheretogo_4} alt="" />
          </div>
          <div className="where__to--go--content">
            <h3 className={darkMode ? "dark-text" : "light-text"}>Rejvíz</h3>
            <p className={darkMode ? "dark-second-text" : "light-second-text"}>
              Nachází se 8 km východně od okresního města Jeseník. Je částí
              města Zlaté Hory a jedná se o nejvýše položenou ves v českém
              Slezsku. Stejnojmenná národní přírodní rezervace je známá svým
              rašeliništěm.
            </p>
            <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/jeseniky/kamsevydat/rejviz">
              <span>Více</span>
            </Link>
          </div>
        </div>  
        :
        <div className="where__to--go--container">
          <div className="where__to--go--image where__to--go--container--locked">
            <img src={wheretogo_4} alt="" />
          </div>
          <div className="where__to--go--content where__to--go--container--locked">
            <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
            <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Zaregistrujte se už dnes a získejte přístup k prémiovým místům
            </p>
            <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
              <span>Více</span>
            </Link>
          </div>
        </div>
        }
         


        </div>
      </section>




      <section className={darkMode ? "where__to--go--main dark" : "where__to--go--main light"}>
        <div className="container">
        
        {user ? 
        
        <div className="where__to--go--container">
          <div className="where__to--go--image">
            <img src={wheretogo_5} alt="" />
          </div>
          <div className="where__to--go--content">
            <h3 className={darkMode ? "dark-text" : "light-text"}>Medvědí Vrch</h3>
            <p className={darkMode ? "dark-second-text" : "light-second-text"}>
              Medvědí vrch má 1216 m. n. m., je nejvyšší vrchol Medvědské hornatiny,
              která tvoří severovýchodní část Hrubého Jeseníku. 
              Na severovýchodním hřbetu Sokolí skála se nacházi
              zřícenina hradu Quinburk z 13. století.
            </p>
            <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/jeseniky/kamsevydat/medvedivrch">
              <span>Více</span>
            </Link>
          </div>
        </div>
        :
        
        <div className="where__to--go--container">
          <div className="where__to--go--image where__to--go--container--locked">
            <img src={wheretogo_5} alt="" />
          </div>
          <div className="where__to--go--content where__to--go--container--locked">
            <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
            <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                Zaregistrujte se už dnes a získejte přístup k prémiovým místům
            </p>
            <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
              <span>Více</span>
            </Link>
          </div>
        </div>
        
        }



        </div>
      </section>
    </>
  );
};

export default KamSeVydatVJesenikach;
